<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>Copyright © 2022 by University of Massachusetts Press</p>
<p class="crt">All rights reserved</p>
<p class="crt">Printed in the United States of America</p>
<p class="cipf">ISBN 978-1-61376-922-5 (ebook)</p>
<p class="crtf">Cover design by Derek Thornton, Notch Design</p>
<p class="crt">Cover photo by Carleton E. Watkins, <i>Yosemite Valley, California,</i> ca. 1865. Courtesy Prints and Photographs Division, Library of Congress, LC-DIG-ppmsca-09983.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Wilson, Brian C., 1960– author.</p>
<p class="cip">Title: The California days of Ralph Waldo Emerson : a travelogue / Brian C.</p>
<p class="cip">   Wilson.</p>
<p class="cip">Description: Amherst : University of Massachusetts Press, [2022] | Includes</p>
<p class="cip">   bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2021054327 (print) | LCCN 2021054328 (ebook) | ISBN</p>
<p class="cip">   9781625346438 (paperback) | ISBN 9781625346445 (hardcover) | ISBN</p>
<p class="cip">   9781613769218 (ebook) | ISBN 9781613769225 (ebook)</p>
<p class="cip">Subjects: LCSH: California—Description and travel. | Emerson, Ralph Waldo,</p>
<p class="cip">   1803–1882—Travel—California. | Emerson, Ralph Waldo, 1803–1882—Last</p>
<p class="cip">   years. | Authors, American—19th century—Biography.</p>
<p class="cip">Classification: LCC F866 .W755 2022  (print) | LCC F866  (ebook) | DDC</p>
<p class="cip">   814/.3 [B]—dc23/eng/20211123</p>
<p class="cip">LC record available at https://lccn.loc.gov/2021054327</p>
<p class="cip">LC ebook record available at https://lccn.loc.gov/2021054328</p>
<p class="cipf">British Library Cataloguing-in-Publication Data</p>
<p class="cip">A catalog record for this book is available from the British Library.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-WILSON-California-0004.vue?4433a91e